import { defineMessages } from 'react-intl';

export const messages: {
	defaultRenderError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	defaultRenderError: {
		id: 'proforma-form-renderer.common.ui.attachment-error-state.default-render-error',
		defaultMessage: 'Unable to show attachments in this field. Refresh this page to try again.',
		description: 'Error message when attachment field fails to render',
	},
});
